import React from 'react'
import Header from '../components/header'
import {
  Box,
  Divider,
  Grid,
  Typography,
  Card,
  CardContent,
} from '@mui/material'

import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined'
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined'

import background from '../_contentnew/pulsebanner2.webp'

const services = [
  {
    title: 'Pallet Supply',
    icon: (
      <Inventory2OutlinedIcon
        sx={{
          fontSize: 80,
          color: '#57C84D',
        }}
      />
    ),
    description:
      'Supplying quality UK pallets, Euro pallets and custom-sized pallets for warehousing, manufacturing, construction and logistics businesses.',
  },
  {
    title: 'Pallet Collection',
    icon: (
      <WarehouseOutlinedIcon
        sx={{
          fontSize: 80,
          color: '#57C84D',
        }}
      />
    ),
    description:
      'We purchase and collect unwanted pallets, helping businesses free up valuable space while keeping usable pallets in circulation.',
  },
  {
    title: 'Mobile Delivery',
    icon: (
      <LocalShippingOutlinedIcon
        sx={{
          fontSize: 80,
          color: '#57C84D',
        }}
      />
    ),
    description:
      'Operating within a 50-mile radius of Basingstoke, we provide fast, reliable pallet delivery directly to your site.',
  },
  {
    title: 'Repair & Reuse',
    icon: (
      <PrecisionManufacturingOutlinedIcon
        sx={{
          fontSize: 80,
          color: '#57C84D',
        }}
      />
    ),
    description:
      'We repair, reuse and recycle pallets wherever possible, reducing waste and creating sustainable pallet solutions for businesses.',
  },
]

const Services = () => {
  return (
    <>
      <Header
        background={background}
        text="Our Services"
      />

      <Box
        sx={{
          backgroundColor: '#0A9B48',
          p: 3,
        }}
      >
        <Typography
          sx={{
            color: '#fff',
            textAlign: 'center',
            fontSize: {
              xs: '1rem',
              md: '1.4rem',
            },
            fontWeight: 600,
          }}
        >
          Reliable pallet supply solutions for businesses across Hampshire.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '90%',
          maxWidth: '1200px',
          mx: 'auto',
          py: 8,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            textAlign: 'center',
            fontWeight: 700,
            mb: 3,
          }}
        >
          Our Services
        </Typography>

        <Typography
          sx={{
            color: '#d7e3dd',
            textAlign: 'center',
            maxWidth: '800px',
            mx: 'auto',
            mb: 6,
            lineHeight: 1.8,
          }}
        >
          Pulse Pallets supports businesses with reliable pallet supply
          solutions. Whether you require standard UK pallets, Euro pallets,
          specialist pallets or bulk quantities, we can help.
        </Typography>

        <Grid
          container
          spacing={3}
          justifyContent="center"
        >
          {services.map((service) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={service.title}
            >
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: '#222023',
                  border: '1px solid rgba(87,200,77,0.15)',
                  transition: 'all 0.3s ease',

                  '&:hover': {
                    borderColor: '#57C84D',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Box
                  sx={{
                    height: '140px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderBottom: '1px solid rgba(87,200,77,0.15)',
                  }}
                >
                  {service.icon}
                </Box>

                <CardContent
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#fff',
                      fontWeight: 700,
                      mb: 2,
                    }}
                  >
                    {service.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: '#d7e3dd',
                      lineHeight: 1.8,
                    }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default Services